import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { AiAssistantRouteId } from './models/ai-assistant-route-id';

export const aiAssistantNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(AiAssistantRouteId.dashboard, { displayName: 'Example dashboard', icon: SolIcon.asm_dashboard }),
    SolNavbarItem.of(AiAssistantRouteId.tracker, { displayName: 'Example tracker', icon: SolIcon.finding }),
    SolNavbarItem.of(AiAssistantRouteId.assistant, {
      displayName: 'AI assistant',
      icon: SolIcon.radar,
      showChildrenInNavbar: false,
      showChildrenAsTabs: true,
      embedTabGroup: true,
      children: [
        SolNavbarItem.of(AiAssistantRouteId.conversations, { displayName: 'Conversations' }),
        SolNavbarItem.of(AiAssistantRouteId.actions, { displayName: 'Action log' }),
        SolNavbarItem.of(AiAssistantRouteId.tools, { displayName: 'Tools' }),
        SolNavbarItem.of(AiAssistantRouteId.skills, { displayName: 'Skills' }),
      ],
    }),
  ],
  system: [],
  account: [],
};
